module.exports = __webpack_public_path__ + "static/media/qr2.1e03c799.jpg";